 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML02_COPYRIGH from '@/components/xhtml/02_Copyrigh'
 import XHTML01_TITLE_PA from '@/components/xhtml/01_Title_Pa'
 import XHTML03_CONTENTS from '@/components/xhtml/03_Contents'
 import XHTML04_A_NOTE_O from '@/components/xhtml/04_A_Note_o'
 import XHTML05_AN_IMAGE from '@/components/xhtml/05_An_Image'
 import XHTML06_ONE___FO from '@/components/xhtml/06_One___Fo'
 import XHTML07_TWO___CO from '@/components/xhtml/07_Two___Co'
 import XHTML08_THREE__ from '@/components/xhtml/08_Three__'
 import XHTML09_FOUR___S from '@/components/xhtml/09_Four___S'
 import XHTML10_FIVE___T from '@/components/xhtml/10_Five___T'
 import XHTML11_SIX___A from '@/components/xhtml/11_Six___A'
 import XHTML12_EPILOGUE from '@/components/xhtml/12_Epilogue'
 import XHTML13_ACKNOWLE from '@/components/xhtml/13_Acknowle'
 import XHTML14_NOTES from '@/components/xhtml/14_Notes'
 import XHTML15_BIBLIOGR from '@/components/xhtml/15_Bibliogr'
 import XHTML16_INDEX from '@/components/xhtml/16_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/03_Contents",
 			"name" : "xhtml/03_Contents",
 			"component" : XHTML03_CONTENTS
 		},
 		{
 			"path" : "/xhtml/04_A_Note_o",
 			"name" : "xhtml/04_A_Note_o",
 			"component" : XHTML04_A_NOTE_O
 		},
 		{
 			"path" : "/xhtml/05_An_Image",
 			"name" : "xhtml/05_An_Image",
 			"component" : XHTML05_AN_IMAGE
 		},
 		{
 			"path" : "/xhtml/06_One___Fo",
 			"name" : "xhtml/06_One___Fo",
 			"component" : XHTML06_ONE___FO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js